import React from 'react';
import { useStyles } from '../../contexts/StyleContext';

const Button = ({ 
  children, 
  variant = 'primary', 
  className = '', 
  disabled = false,
  onClick,
  type = 'button',
  ...props 
}) => {
  const styles = useStyles();
  const { button } = styles;

  const getButtonStyles = () => {
    const baseStyle = {
      opacity: disabled ? 0.6 : 1,
      cursor: disabled ? 'not-allowed' : 'pointer',
      color: '#FFFFFF'  // Always white text
    };

    switch (variant) {
      case 'primary':
        return {
          ...baseStyle,
          background: button.primary.background
        };
      case 'secondary':
        return {
          ...baseStyle,
          background: button.secondary.background
        };
      case 'accent':
        return {
          ...baseStyle,
          background: button.accent.background
        };
      default:
        return baseStyle;
    }
  };

  const buttonClasses = `
    px-6 
    py-3 
    rounded-lg 
    font-medium 
    transition-all 
    duration-200 
    transform 
    hover:-translate-y-0.5
    shadow-md 
    hover:shadow-lg
    text-white
    ${className}
  `.trim();

  return (
    <button
      type={type}
      className={buttonClasses}
      style={getButtonStyles()}
      disabled={disabled}
      onClick={disabled ? undefined : onClick}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
